import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReject = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 11,
	viewBox: "0 0 10 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.72406 0.781563C9.43156 0.489063 8.95906 0.489063 8.66656 0.781563L4.99906 4.44156L1.33156 0.774062C1.03906 0.481563 0.566562 0.481563 0.274062 0.774062C-0.0184375 1.06656 -0.0184375 1.53906 0.274062 1.83156L3.94156 5.49906L0.274062 9.16656C-0.0184375 9.45906 -0.0184375 9.93156 0.274062 10.2241C0.566562 10.5166 1.03906 10.5166 1.33156 10.2241L4.99906 6.55656L8.66656 10.2241C8.95906 10.5166 9.43156 10.5166 9.72406 10.2241C10.0166 9.93156 10.0166 9.45906 9.72406 9.16656L6.05656 5.49906L9.72406 1.83156C10.0091 1.54656 10.0091 1.06656 9.72406 0.781563Z",
		fill: "white"
	})
});
export default SvgReject;
